import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BOM_OWNER_DASHBOARD_STAT } from "./apiRoutes";

interface UseGetIncomeChartDataProps {
  year: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getIncomeChartData = async (communityId: string, year: string) =>
  await axiosAuth.get(
    `${BOM_OWNER_DASHBOARD_STAT(communityId)}/income-chart?budgetYear=${year}`
  );

const useGetIncomeChartData = ({
  year,
  communityId,
  queryParams,
}: UseGetIncomeChartDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owner-income-chart-data", communityId, year],
    queryFn: () => getIncomeChartData(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetIncomeChartData;
